import { render } from "./DesignForm.vue?vue&type=template&id=77939f38&scoped=true&ts=true"
import script from "./DesignForm.vue?vue&type=script&lang=ts"
export * from "./DesignForm.vue?vue&type=script&lang=ts"

import "./DesignForm.vue?vue&type=style&index=0&id=77939f38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77939f38"]])

export default __exports__